import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import React from "react";
import FilePreviewComponent from "@/components/FilePreviewComponent/FilePreviewComponent";
import { AssetTypes } from "@/model/AssetTypes";
import { APOfferVacancyMeta } from '../../../model/VacancyApplicant.interface';

type Props = { offer: APOffer };

const VacancyContractAttachment = (props: Props) => {
  const { offer } = props;
  const offerMeta = offer?.data.meta as APOfferVacancyMeta;

  return (
    <div>
      {offerMeta?.contracts?.map((c, i) => {
        if (!c) {
          return null;
        }

        if (!c.linkToCdn) {
          return null;
        }
        if (c.type === "manual") {
          return (
            <div key={c.documentId}>
              <FilePreviewComponent
                type="cdn"
                asset={offer}
                assetType={AssetTypes.ActivityRelated.Offer}
                assetField={"data.meta.contracts"}
                cdnID={c.linkToCdn}
                height={60}
                width={60}
                hasFolderPermissions
                dimension="thumb"
              />
            </div>
          );
        }

        return (
          <div key={c.documentId}>
            <FilePreviewComponent
              type="cdn"
              asset={offer}
              assetType={AssetTypes.ActivityRelated.Offer}
              assetField={"data.meta.contracts"}
              cdnID={c.linkToCdn}
              height={60}
              width={60}
              hasFolderPermissions
              dimension="thumb"
            />
          </div>
        );
      })}
    </div>
  );
};

export default VacancyContractAttachment;
